import { FC } from 'react';
import clsx from 'clsx';
import { MdNotifications } from 'react-icons/md';
import NotificationBadge from '../NotificationBadge';
import { isBellJobFinale } from './bellJobFx';
import { IBellJobFxScene } from './useBellJobFx';
import './NotificationBell.scss';

export interface INotificationBellProps {
    unreadCount: number;
    /** Идёт фоновая задача — кольцо вращается. */
    jobRunning: boolean;
    /** Звонок о новом уведомлении; новый ключ проигрывает его с начала. */
    ringing: boolean;
    ringingKey: number;
    jobScene?: IBellJobFxScene | null;
    failureMark?: boolean;
}

const SWING = { success: 'soft', failure: 'alert' } as const;

/** Содержимое кнопки колокольчика: иконка, кольцо фоновых задач, метки итога и счётчик непрочитанных. */
const NotificationBell: FC<INotificationBellProps> = ({
    unreadCount,
    jobRunning,
    ringing,
    ringingKey,
    jobScene = null,
    failureMark = false,
}) => {
    // Финал играет кольцо, которое осталось после последней задачи; новая задача прерывает его вращением.
    const finale = !jobRunning && jobScene && isBellJobFinale(jobScene.fx) ? jobScene.fx : null;
    const flash = jobRunning && jobScene && !isBellJobFinale(jobScene.fx) ? jobScene : null;
    const arrived = jobScene?.fx === 'arrive';
    const swing = finale === 'success' || finale === 'failure' ? SWING[finale] : arrived ? 'catch' : null;

    return (
        <div className="notification-bell">
            {(jobRunning || finale) && (
                <span
                    className={clsx('notification-bell__job-ring', finale && `notification-bell__job-ring--${finale}`)}
                    aria-hidden="true"
                >
                    <svg width="38" height="38" viewBox="0 0 38 38">
                        <circle className="notification-bell__job-track" cx="19" cy="19" r="17" />
                        <circle className="notification-bell__job-arc" cx="19" cy="19" r="17" />
                        {flash && (
                            <circle
                                key={flash.id}
                                className={`notification-bell__job-flash notification-bell__job-flash--${flash.fx}`}
                                cx="19"
                                cy="19"
                                r="17"
                            />
                        )}
                    </svg>
                </span>
            )}
            <span
                key={ringingKey}
                className={clsx('notification-bell__icon-wrap', ringing && 'notification-bell__icon-wrap--ringing')}
            >
                <span
                    key={swing ? jobScene?.id : 'still'}
                    className={clsx('notification-bell__swing', swing && `notification-bell__swing--${swing}`)}
                >
                    <MdNotifications size="32" className="notification-bell__icon" />
                </span>
            </span>
            {failureMark && <span className="notification-bell__job-alert" aria-hidden="true" />}
            {finale === 'success' && (
                <span key={jobScene?.id} className="notification-bell__job-check" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 14 14">
                        <path d="m4 7.2 2 2 4-4.3" />
                    </svg>
                </span>
            )}
            <NotificationBadge count={unreadCount} />
        </div>
    );
};

export default NotificationBell;
